import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AreaDeleteOptionsCardBase } from '../area-delete-options-card-base';

@Component({
    selector: 'fi-area-delete-area-content-options-card',
    templateUrl: './area-delete-area-content-options-card.component.html',
    styleUrls: ['./area-delete-area-content-options-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AreaDeleteAreaContentOptionsCardComponent extends AreaDeleteOptionsCardBase {
    getItemsToDelete(): any[] {
        return this.areaToDeleteData.ItemsToDeleteByAreaRights;
    }
}
